import React from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';
import sponsor from '../../assets/images/sponsor.svg';
import './SponsorIcon.scss';

export interface SponsorIconProps {
    id: string;
}
export const SponsorIcon = (props: SponsorIconProps) => {
    return (
        <>
            <img
                src={sponsor}
                className="sponsor"
                id={props.id}
                data-tooltip-content="Your Sponsor"></img>
            {createPortal(
                <Tooltip
                    place="top"
                    className="sponsor-tooltip"
                    anchorId={props.id}
                    border="1px solid #cdcdcd"
                    opacity={1}
                    offset={15}
                />,
                document.body
            )}
        </>
    );
};
